import { Component, Input, inject } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { Store } from "@ngrx/store";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogTitle,
  MatDialogActions
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TeamStore } from "@app/services/store/team-store";
import { Team } from "@app/models/rest/team";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatLabel, MatError } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-teams-add",
  templateUrl: "./teams-add.component.html",
  styleUrls: ["./teams-add.component.scss"],
  imports: [
    MatDialogTitle,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatFormField,
    MatInput,
    MatLabel,
    MatError,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class TeamsAddComponent {
  teamStore = inject(TeamStore);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);
  protected router = inject(Router);
  dialogRef = inject<MatDialogRef<TeamsAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  teamForm = new UntypedFormGroup({
    teamNameFC: new UntypedFormControl("")
  });

  @Input()
  team: Team;

  // getErrorMessage(controlName: string) {
  //   console.log(this.teamForm.controls[teamNameFC].errors);
  //   console.log('get error');
  //   return this.teamForm.controls[teamNameFC].errors.server;
  // }

  addTeam(): void {
    const team: Team = new Team();

    team.name = this.teamForm.controls["teamNameFC"].value;

    this.teamStore.create(team).subscribe(
      (value) => {
        console.log("success");
        this.dialogRef.close({ success: true });
      },
      (error) => {
        console.log("error");
        console.log(error);
        // alert(error.error.message)
      }
    );
  }

  onCancelClick() {
    this.dialogRef.close();
  }
}
